module.exports = __webpack_public_path__ + "img/favicon-16x16.png";